import TransactionNewForm from '../Components/TransactionNewForm';

function New() {
  return (
    <div>
      <h2>Create New Transaction Here</h2>
      <TransactionNewForm />
    </div>
  );
}

export default New;